/* assets/bee_scorer.js: screens for the scoring page (templates/page.scoring.liquid).
 * Scoring rules live in bee_scorer_logic.js; the Google Sheet side is
 * apps_script/scoring.gs. See docs/scoring-page.md.
 *
 * Everything the judge does is saved on the iPad first (localStorage), so a
 * sleep, reload or wifi drop never loses a game. Finished games wait in an
 * outbox and are re-sent until the sheet confirms them.
 */
(function () {
  'use strict';
  var L = window.BeeScorerLogic;
  var CONFIG = JSON.parse(document.getElementById('bee-scorer-config').textContent);
  var DEMO = !CONFIG.endpoint || CONFIG.endpoint.indexOf('REPLACE') >= 0;
  var COURTS = CONFIG.courts || 3;

  /* ---------- storage ---------- */
  var LS = {
    get: function (k, d) {
      try { var v = localStorage.getItem('bee_scorer_' + k); return v == null ? d : JSON.parse(v); } catch (e) { return d; }
    },
    set: function (k, v) {
      try { localStorage.setItem('bee_scorer_' + k, JSON.stringify(v)); return true; } catch (e) { return false; }
    },
    del: function (k) { try { localStorage.removeItem('bee_scorer_' + k); } catch (e) {} },
  };

  var cfg = LS.get('cfg', { pin: null, scorer: null, court: 1, event: null });
  var schedule = LS.get('schedule', null);
  var outbox = LS.get('outbox', []);
  var game = LS.get('game', null);
  var lastFetchFailed = false;
  var viewFlip = false;

  var $ = function (id) { return document.getElementById(id); };
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function show(id) {
    document.querySelectorAll('#bee-scorer .screen').forEach(function (s) { s.hidden = s.id !== id; });
    if (id === 's-score') keepAwake(); else releaseAwake();
  }
  function saveCfg() { LS.set('cfg', cfg); }
  var tt;
  function toast(msg) {
    var x = $('toast'); x.textContent = msg; x.classList.add('show');
    clearTimeout(tt); tt = setTimeout(function () { x.classList.remove('show'); }, 2600);
  }
  function rules() { return L.withDefaults(schedule && schedule.rules); }

  /* ---------- talking to the Google Sheet ---------- */
  var api = DEMO ? demoApi() : {
    schedule: function (pin) {
      return fetch(CONFIG.endpoint + '?action=schedule&pin=' + encodeURIComponent(pin))
        .then(function (r) { return r.json(); })
        .then(function (d) { if (!d.ok) throw apiError(d.error); return d; });
    },
    submit: function (pin, payload) {
      // A plain-text body keeps this a "simple" request, so Apps Script answers without a CORS preflight.
      return fetch(CONFIG.endpoint, { method: 'POST', body: JSON.stringify({ action: 'submit', pin: pin, game: payload }) })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (!d.ok) throw apiError(d.error); return d; });
    },
  };
  function apiError(code) { var e = new Error(code); e.api = true; return e; }

  function refreshSchedule() {
    if (!cfg.pin) return Promise.resolve();
    return api.schedule(cfg.pin).then(function (d) {
      schedule = d; LS.set('schedule', d); lastFetchFailed = false;
      updateSyncPill();
      if (!$('s-home').hidden) drawHome();
    }).catch(function (err) {
      if (err.api && err.message === 'bad_pin' && !game) { cfg.pin = null; saveCfg(); route(); return; }
      lastFetchFailed = !err.api;
      updateSyncPill();
    });
  }

  /* ---------- schedule helpers ---------- */
  function events() { return (schedule && schedule.events) || []; }
  function flightsFor(ev) { return ((schedule && schedule.flights) || []).filter(function (f) { return f.event === ev; }); }
  function flightById(id) { return ((schedule && schedule.flights) || []).filter(function (f) { return f.id === id; })[0]; }
  function rrGameId(f, r, c) { return f.id + '-R' + (r + 1) + '-C' + (c + 1); }
  function medalGameId(f, label) { return f.id + '-' + label.toLowerCase().replace(/[^a-z0-9]+/g, '-'); }
  function pendingFor(id) { return outbox.filter(function (o) { return o.gameId === id && o.status !== 'error'; }).pop(); }
  function scoredFor(id) {
    var p = pendingFor(id);
    if (p) return { scoreA: p.payload.scoreA, scoreB: p.payload.scoreB };
    return schedule && schedule.scored && schedule.scored[id];
  }
  function teamName(f, n) { return (f.teams && f.teams[n]) || 'Team ' + n + ' (name missing)'; }

  function pickEvent() {
    var evs = events();
    if (cfg.event && evs.some(function (e) { return e.id === cfg.event; })) return cfg.event;
    var d = new Date();
    var today = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    var match = evs.filter(function (e) { return e.date === today; })[0] || evs.filter(function (e) { return e.date > today; })[0] || evs[0];
    return match ? match.id : null;
  }

  function nextGame(ev, c) {
    var fs = flightsFor(ev);
    for (var i = 0; i < fs.length; i++) {
      for (var r = 0; r < fs[i].rounds.length; r++) {
        var pair = fs[i].rounds[r] && fs[i].rounds[r][c];
        if (pair && !scoredFor(rrGameId(fs[i], r, c))) return { f: fs[i], r: r, c: c, pair: pair };
      }
    }
    return null;
  }
  function gamesLeft(ev, c) {
    var n = 0;
    flightsFor(ev).forEach(function (f) {
      f.rounds.forEach(function (round, r) { if (round && round[c] && !scoredFor(rrGameId(f, r, c))) n++; });
    });
    return n;
  }

  /* ---------- PIN ---------- */
  var pin = '';
  ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', '⌫'].forEach(function (k) {
    var b = document.createElement('button');
    b.textContent = k;
    if (!k) { b.style.visibility = 'hidden'; b.tabIndex = -1; }
    if (k === '⌫') b.setAttribute('aria-label', 'Delete');
    b.onclick = function () {
      if (k === '⌫') pin = pin.slice(0, -1); else if (pin.length < 4) pin += k;
      drawPin();
      if (pin.length === 4) checkPin();
    };
    $('keypad').appendChild(b);
  });
  function drawPin() {
    Array.prototype.forEach.call($('pinDots').children, function (d, i) { d.classList.toggle('on', i < pin.length); });
  }
  function checkPin() {
    $('pinErr').textContent = 'Checking…';
    api.schedule(pin).then(function (d) {
      cfg.pin = pin; saveCfg(); schedule = d; LS.set('schedule', d);
      $('pinErr').textContent = ''; pin = ''; drawPin(); route();
    }).catch(function (err) {
      $('pinErr').textContent = err.api && err.message === 'bad_pin'
        ? 'That PIN isn’t right. Try again.'
        : err.api ? 'The scoring sheet isn’t set up yet (' + err.message + '). Ask the tournament director.'
          : 'Can’t reach the Google Sheet. Check the wifi and try again.';
      setTimeout(function () { pin = ''; drawPin(); }, 600);
    });
  }
  if (DEMO) $('pinErr').textContent = 'DEMO MODE: not connected to the sheet. PIN is 2026.';

  /* ---------- scorer name ---------- */
  $('nameGo').onclick = function () {
    var v = $('scorerName').value.trim();
    if (v.length < 2) { $('nameErr').textContent = 'Type your name first.'; $('scorerName').focus(); return; }
    $('nameErr').textContent = ''; cfg.scorer = v; saveCfg(); route();
  };
  $('scorerName').addEventListener('keydown', function (e) { if (e.key === 'Enter') $('nameGo').click(); });
  $('changeName').onclick = function () { cfg.scorer = null; saveCfg(); route(); };

  /* ---------- home ---------- */
  function drawHome() {
    cfg.event = pickEvent();
    $('whoPill').textContent = '👤 ' + cfg.scorer;
    updateSyncPill();
    var row = $('eventRow'); row.innerHTML = '';
    events().forEach(function (e) {
      var b = document.createElement('button');
      b.className = 'card' + (e.id === cfg.event ? ' sel' : '');
      var d = new Date(e.date + 'T12:00:00');
      b.innerHTML = esc(e.name) + '<small>' + d.toLocaleDateString('en-US', { weekday: 'long', month: 'numeric', day: 'numeric' }) + '</small>';
      b.onclick = function () { cfg.event = e.id; saveCfg(); drawHome(); };
      row.appendChild(b);
    });
    var cg = $('courtGrid'); cg.innerHTML = '';
    for (var c = 0; c < COURTS; c++) (function (c) {
      var b = document.createElement('button');
      b.className = 'card' + (cfg.court === c + 1 ? ' sel' : '');
      var left = gamesLeft(cfg.event, c);
      b.innerHTML = 'Court ' + (c + 1) + '<small>' + left + (left === 1 ? ' game' : ' games') + ' left today</small>';
      b.onclick = function () { cfg.court = c + 1; saveCfg(); drawHome(); };
      cg.appendChild(b);
    })(c);

    var w = $('nextWrap');
    if (!schedule) { w.innerHTML = '<div class="card">Loading today’s games…</div>'; return; }
    var n = nextGame(cfg.event, cfg.court - 1);
    if (!n) {
      w.innerHTML = '<div class="card">🎉 Every round robin game on Court ' + cfg.court + ' is scored for today.' +
        '<small>For a medal round game, tap “Medal round game” below.</small></div>';
      return;
    }
    var a = n.pair[0], b2 = n.pair[1];
    w.innerHTML = '<button class="big next" id="goNext">▶ Score next game on Court ' + cfg.court +
      '<small>' + esc(n.f.name) + (n.f.time ? ' · ' + esc(n.f.time) : '') + ' · Round ' + (n.r + 1) + '</small>' +
      '<div class="team-line">Team ' + a + ': ' + esc(teamName(n.f, a)) + '</div><div class="vs">vs</div>' +
      '<div class="team-line">Team ' + b2 + ': ' + esc(teamName(n.f, b2)) + '</div></button>';
    $('goNext').onclick = function () { beginRR(n.f, n.r, n.c); };
  }

  function beginRR(f, r, c) {
    var pair = f.rounds[r][c];
    beginSetup({
      gameId: rrGameId(f, r, c), event: f.event, flight: f.id, flightName: f.name, stage: 'Round robin',
      round: r + 1, court: c + 1, teams: pair.slice(), names: [teamName(f, pair[0]), teamName(f, pair[1])],
    });
  }

  // A game the sheet already has needs a deliberate hold before it's scored again.
  function confirmRescore(id, then) {
    var s = scoredFor(id);
    if (!s) return then();
    holdConfirm('This game is already scored', 'The sheet has ' + s.scoreA + ' – ' + s.scoreB +
      '. Scoring it again will replace that score. Hold the red button to go ahead.', then);
  }

  /* ---------- pick any game ---------- */
  var allFlight = null;
  $('openAll').onclick = function () {
    var fs = flightsFor(cfg.event);
    var n = nextGame(cfg.event, cfg.court - 1);
    allFlight = (n && n.f.id) || (fs[0] && fs[0].id);
    drawAll(); $('ov-all').hidden = false;
  };
  $('allClose').onclick = function () { $('ov-all').hidden = true; };
  function drawAll() {
    var fg = $('allFlights'); fg.innerHTML = '';
    flightsFor(cfg.event).forEach(function (f) {
      var b = document.createElement('button');
      b.className = 'card' + (f.id === allFlight ? ' sel' : '');
      b.innerHTML = esc(f.name.replace(/^\w+ Doubles - /, '')) + '<small>' + esc(f.time) + '</small>';
      b.onclick = function () { allFlight = f.id; drawAll(); };
      fg.appendChild(b);
    });
    var gg = $('allGames'); gg.innerHTML = '';
    var f = flightById(allFlight); if (!f) return;
    f.rounds.forEach(function (round, r) {
      (round || []).forEach(function (pair, c) {
        if (!pair) return;
        var id = rrGameId(f, r, c), s = scoredFor(id);
        var b = document.createElement('button');
        b.className = 'card' + (s ? ' done' : '');
        b.innerHTML = 'Round ' + (r + 1) + ' · Court ' + (c + 1) +
          '<small>Team ' + pair[0] + ' vs Team ' + pair[1] + (s ? ' · scored ' + s.scoreA + '–' + s.scoreB : '') + '</small>';
        b.onclick = function () { confirmRescore(id, function () { $('ov-all').hidden = true; beginRR(f, r, c); }); };
        gg.appendChild(b);
      });
    });
  }

  /* ---------- medal round ---------- */
  var medal = { flight: null, label: null, teams: [] };
  $('openMedal').onclick = function () {
    var fs = flightsFor(cfg.event);
    medal = { flight: medal.flight && flightById(medal.flight) ? medal.flight : (fs[0] && fs[0].id), label: null, teams: [] };
    drawMedal(); $('ov-medal').hidden = false;
  };
  $('medalClose').onclick = function () { $('ov-medal').hidden = true; };
  function drawMedal() {
    $('medalErr').textContent = '';
    var fg = $('medalFlights'); fg.innerHTML = '';
    flightsFor(cfg.event).forEach(function (f) {
      var b = document.createElement('button');
      b.className = 'card' + (f.id === medal.flight ? ' sel' : '');
      b.innerHTML = esc(f.name.replace(/^\w+ Doubles - /, '')) + '<small>' + esc(f.time) + '</small>';
      b.onclick = function () { medal.flight = f.id; medal.teams = []; drawMedal(); };
      fg.appendChild(b);
    });
    var f = flightById(medal.flight);
    var mg = $('medalGames'); mg.innerHTML = '';
    (CONFIG.medalGames || []).forEach(function (label) {
      var b = document.createElement('button');
      var s = f && scoredFor(medalGameId(f, label));
      b.className = 'card' + (label === medal.label ? ' sel' : '') + (s ? ' done' : '');
      b.innerHTML = esc(label) + (s ? '<small>scored ' + s.scoreA + '–' + s.scoreB + '</small>' : '');
      b.onclick = function () { medal.label = label; drawMedal(); };
      mg.appendChild(b);
    });
    var tg = $('medalTeams'); tg.innerHTML = '';
    if (!f) return;
    var st = schedule.standings && schedule.standings[f.id];
    var order = st ? st.rows.map(function (r) { return r.team; }) : [1, 2, 3, 4, 5, 6];
    var spots = schedule.medalSpots || 4;
    order.forEach(function (n, i) {
      var b = document.createElement('button');
      var picked = medal.teams.indexOf(n);
      b.className = 'card' + (picked >= 0 ? ' sel' : '');
      var rank = st ? '#' + (i + 1) + (i < spots ? ' 🏅' : '') + ' · ' : '';
      b.innerHTML = 'Team ' + n + (picked >= 0 ? ' ✓' : '') + '<small>' + rank + esc(teamName(f, n)) + '</small>';
      b.onclick = function () {
        if (picked >= 0) medal.teams.splice(picked, 1);
        else if (medal.teams.length < 2) medal.teams.push(n);
        else medal.teams = [medal.teams[1], n];
        drawMedal();
      };
      tg.appendChild(b);
    });
    $('medalHelp').textContent = st && st.complete
      ? 'Round robin is finished. Teams are listed by standing; 🏅 = medal round.'
      : st ? 'Round robin not finished yet (' + st.gamesDone + ' of ' + st.gamesTotal + ' games). Teams listed by current standing.'
        : 'Pick the flight, the game, then the two teams.';
  }
  $('medalGo').onclick = function () {
    var f = flightById(medal.flight);
    if (!f || !medal.label || medal.teams.length !== 2) {
      $('medalErr').textContent = 'Pick a flight, a game (like Semifinal 1) and two teams.'; return;
    }
    var id = medalGameId(f, medal.label), t = medal.teams.slice();
    confirmRescore(id, function () {
      $('ov-medal').hidden = true;
      beginSetup({
        gameId: id, event: f.event, flight: f.id, flightName: f.name, stage: medal.label, round: '', court: cfg.court,
        teams: t, names: [teamName(f, t[0]), teamName(f, t[1])],
      });
    });
  };

  /* ---------- setup: first server + sides ---------- */
  var setup = null;
  function beginSetup(meta) {
    var split = function (name) { var p = name.split(' / '); return [p[0] || 'Player 1', p[1] || 'Player 2']; };
    setup = { meta: meta, first: null, pos: [split(meta.names[0]), split(meta.names[1])] };
    $('setupInfo').textContent = (meta.stage === 'Round robin' ? 'Round ' + meta.round : meta.stage) + ' · Court ' + meta.court;
    $('step1').hidden = false; $('step2').hidden = true;
    var g = $('firstGrid'); g.innerHTML = '';
    [0, 1].forEach(function (t) {
      var b = document.createElement('button');
      b.className = 'big first-btn' + (t ? ' navy' : '');
      b.innerHTML = 'Team ' + meta.teams[t] + '<small>' + esc(meta.names[t]) + '</small><br>🏓 serves first';
      b.onclick = function () { setup.first = t; $('step1').hidden = true; $('step2').hidden = false; drawSides(); };
      g.appendChild(b);
    });
    show('s-setup');
  }
  function drawSides() {
    var box = $('sideSet'); box.innerHTML = '';
    [0, 1].forEach(function (t) {
      var d = document.createElement('div');
      d.className = 'side-box';
      d.innerHTML = '<h3>Team ' + setup.meta.teams[t] + (setup.first === t ? ' · serves first' : '') + '</h3>' +
        '<div class="court"><div><span>LEFT side</span>' + esc(setup.pos[t][1]) + '</div><div><span>RIGHT side</span>' + esc(setup.pos[t][0]) + '</div></div>' +
        '<button class="swap">⇄ Swap</button>';
      d.querySelector('.swap').onclick = function () { setup.pos[t].reverse(); drawSides(); };
      box.appendChild(d);
    });
  }
  $('setupBack').onclick = function () {
    if (!$('step2').hidden) { $('step2').hidden = true; $('step1').hidden = false; return; }
    show('s-home'); drawHome();
  };
  $('startGame').onclick = function () {
    game = {
      meta: setup.meta, scorer: cfg.scorer, startedAt: new Date().toISOString(), firstServer: setup.meta.teams[setup.first],
      s: L.newGame(setup.first, setup.pos, rules()), hist: [], log: [], manual: false,
    };
    persist(); show('s-score'); drawScore();
  };

  /* ---------- scoring ---------- */
  function persist() {
    var ok = LS.set('game', game);
    var p = $('savePill'); p.className = 'pill ' + (ok ? 'ok' : 'bad'); p.textContent = ok ? '✓ Saved on iPad' : '⚠ Not saved on iPad';
  }
  function push(token) { game.hist.push({ s: L.clone(game.s), log: game.log.length }); if (token) game.log.push(token); }

  function rally(t) {
    if (L.winner(game.s) >= 0) return openFinal();
    push(null);
    var r = L.rally(game.s, t);
    game.s = r.state;
    var letter = t === 0 ? 'A' : 'B';
    game.log.push(r.outcome === 'frozen' ? letter.toLowerCase() : letter);
    persist(); drawScore(); flash(t);
    var tn = 'Team ' + game.meta.teams[t];
    toast(r.outcome === 'point' ? 'Point ' + tn
      : r.outcome === 'sideout' ? 'Point and serve to ' + tn
        : 'Serve to ' + tn + ', no point: at ' + rules().freeze + ' they can only win on their own serve');
    if (L.winner(game.s) >= 0) setTimeout(openFinal, 450);
  }
  function undo() {
    if (!game.hist.length) return toast('Nothing to undo');
    var h = game.hist.pop();
    game.s = h.s; game.log.length = h.log;
    persist(); drawScore(); toast('Undone ↶');
  }
  $('undoBtn').onclick = undo;
  $('flipBtn').onclick = function () { viewFlip = !viewFlip; drawScore(); };

  function drawScore() {
    var s = game.s, m = game.meta, order = viewFlip ? [1, 0] : [0, 1];
    $('scInfo').textContent = 'Court ' + m.court + ' · ' + (m.stage === 'Round robin' ? 'Round ' + m.round : m.stage) + ' · ' + m.flightName.replace(/ Doubles - /, ' ');
    var sv = L.serverInfo(s), c = L.call(s);
    $('callNum').textContent = c[0] + ' – ' + c[1];
    $('callWho').innerHTML = 'Team ' + m.teams[s.server] + ' serving<br>🏓 <b>' + esc(sv.player) + '</b> serves from the <b>' + sv.side + '</b>' +
      (L.isFrozen(s, s.server) ? ' · <b class="gp">GAME POINT</b>' : '');
    var P = $('panels'); P.innerHTML = '';
    order.forEach(function (t) {
      var el = document.createElement('button');
      el.className = 'team ' + (t ? 'B' : 'A') + (s.server === t ? ' serving' : '');
      el.dataset.t = t;
      el.setAttribute('aria-label', 'Team ' + m.teams[t] + ' won the rally');
      el.innerHTML = (s.server === t ? '<div class="badge">🏓 SERVING</div>' : '') +
        (L.isFrozen(s, t) ? '<div class="frz">❄ AT ' + s.rules.freeze + ' · wins only on serve</div>' : '') +
        '<div class="tn">Team ' + m.teams[t] + '</div><div class="names">' + esc(m.names[t]) + '</div>' +
        '<div class="pts">' + s.score[t] + '</div>' +
        '<div class="tap">Tap if they WON the rally</div>' +
        '<div class="posline">L: ' + esc(s.pos[t][1]) + ' · R: ' + esc(s.pos[t][0]) + '</div><div class="flash"></div>';
      el.onclick = function () { rally(t); };
      P.appendChild(el);
    });
    [['toL', order[0]], ['toR', order[1]]].forEach(function (x) {
      var b = $(x[0]), t = x[1];
      b.textContent = '⏱ Timeout Team ' + m.teams[t] + ' (' + s.timeoutsLeft[t] + ' left)';
      b.disabled = !s.timeoutsLeft[t];
      b.onclick = function () { openTimeout(t); };
    });
  }
  function flash(t) {
    var el = Array.prototype.filter.call($('panels').children, function (e) { return +e.dataset.t === t; })[0];
    if (el) { el.classList.remove('hit'); void el.offsetWidth; el.classList.add('hit'); }
  }

  /* timeouts (players may switch sides only here) */
  var toTimer;
  function openTimeout(t) {
    if (!game.s.timeoutsLeft[t]) return;
    push('T' + (t ? 'B' : 'A'));
    game.s.timeoutsLeft[t]--; persist();
    $('toTitle').textContent = 'TIMEOUT · TEAM ' + game.meta.teams[t];
    var left = rules().timeoutSeconds;
    var fmt = function (n) { return Math.floor(n / 60) + ':' + String(n % 60).padStart(2, '0'); };
    $('toClock').textContent = fmt(left);
    clearInterval(toTimer);
    toTimer = setInterval(function () {
      left--; $('toClock').textContent = left > 0 ? fmt(left) : 'TIME';
      if (left <= 0) clearInterval(toTimer);
    }, 1000);
    var g = $('toSwaps'); g.innerHTML = '';
    [0, 1].forEach(function (x) {
      var b = document.createElement('button');
      b.className = 'big ghost';
      var label = function () {
        return 'Team ' + game.meta.teams[x] + ' switched sides<small>L: ' + esc(game.s.pos[x][1]) + ' · R: ' + esc(game.s.pos[x][0]) + '</small>';
      };
      b.innerHTML = label();
      b.onclick = function () { game.s.pos[x].reverse(); game.log.push('S' + (x ? 'B' : 'A')); persist(); b.innerHTML = label(); b.classList.toggle('yellow'); };
      g.appendChild(b);
    });
    $('ov-timeout').hidden = false;
  }
  $('toDone').onclick = function () { clearInterval(toTimer); $('ov-timeout').hidden = true; drawScore(); };

  /* game over */
  function openFinal() {
    var s = game.s, w = L.winner(s), l = 1 - w;
    $('finWinner').textContent = 'Team ' + game.meta.teams[w] + ' wins';
    $('finScore').textContent = s.score[w] + ' – ' + s.score[l];
    $('ov-final').hidden = false;
  }
  $('finNo').onclick = function () { $('ov-final').hidden = true; undo(); };
  $('finYes').onclick = function () { $('ov-final').hidden = true; submitGame(); };

  /* more: type the score in, or throw the game away */
  $('moreBtn').onclick = function () { $('ov-more').hidden = false; };
  $('mClose').onclick = function () { $('ov-more').hidden = true; };
  $('mCancel').onclick = function () {
    $('ov-more').hidden = true;
    holdConfirm('Throw this game away?', 'The score so far will be deleted from this iPad. Hold the red button.', function () {
      LS.del('game'); game = null; show('s-home'); drawHome();
    });
  };

  var man = [0, 0];
  $('mManual').onclick = function () {
    $('ov-more').hidden = true; man = game.s.score.slice(); drawMan(); $('ov-manual').hidden = false;
  };
  function drawMan() {
    var r = rules();
    $('manHelp').textContent = r.winBy === 1
      ? 'The winner must have exactly ' + r.target + ', the other team ' + (r.target - 1) + ' or less.'
      : 'Games go to ' + r.target + ', win by ' + r.winBy + '.';
    var g = $('manGrid'); g.innerHTML = '';
    var max = r.target + (r.winBy >= 2 ? 15 : 0);
    [0, 1].forEach(function (t) {
      var box = document.createElement('div');
      box.innerHTML = '<div class="man-team">Team ' + game.meta.teams[t] + '</div><div class="stepper"><button aria-label="minus">−</button><div class="v">' + man[t] + '</div><button aria-label="plus">+</button></div>';
      var bs = box.querySelectorAll('button');
      bs[0].onclick = function () { man[t] = Math.max(0, man[t] - 1); drawMan(); };
      bs[1].onclick = function () { man[t] = Math.min(max, man[t] + 1); drawMan(); };
      g.appendChild(box);
    });
    $('manErr').textContent = '';
  }
  $('manBack').onclick = function () { $('ov-manual').hidden = true; };
  $('manGo').onclick = function () {
    if (!L.validFinal(man[0], man[1], rules())) {
      $('manErr').textContent = man[0] === man[1] ? 'Both teams can’t have the same score.' : 'A game can’t end ' + man[0] + ' – ' + man[1] + '. ' + $('manHelp').textContent;
      return;
    }
    $('ov-manual').hidden = true;
    push('M'); game.s.score = man.slice(); game.manual = true; persist(); drawScore(); openFinal();
  };

  /* hold-to-confirm for anything that throws away or replaces a score */
  var holdT, holdThen;
  function holdConfirm(title, text, then) {
    $('holdTitle').textContent = title; $('holdText').textContent = text; holdThen = then; $('ov-hold').hidden = false;
  }
  $('holdNo').onclick = function () { $('ov-hold').hidden = true; };
  (function () {
    var y = $('holdYes');
    var start = function (e) {
      e.preventDefault(); y.textContent = 'Keep holding…';
      holdT = setTimeout(function () { $('ov-hold').hidden = true; y.textContent = 'Hold to confirm'; var t = holdThen; holdThen = null; if (t) t(); }, 1500);
    };
    var end = function () { clearTimeout(holdT); y.textContent = 'Hold to confirm'; };
    y.addEventListener('pointerdown', start);
    y.addEventListener('pointerup', end);
    y.addEventListener('pointerleave', end);
    y.addEventListener('pointercancel', end);
  })();

  /* ---------- saving: iPad first, then the outbox sends to the sheet ---------- */
  function submitGame() {
    var g = game, m = g.meta, s = g.s;
    var timeoutsUsed = function (t) { return s.rules.timeouts - s.timeoutsLeft[t]; };
    var payload = {
      gameId: m.gameId, clientId: m.gameId + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7),
      event: m.event, flight: m.flight, stage: m.stage, round: m.round, court: m.court,
      teamA: m.teams[0], teamAName: m.names[0], teamB: m.teams[1], teamBName: m.names[1],
      scoreA: s.score[0], scoreB: s.score[1], scorer: g.scorer, firstServer: g.firstServer,
      timeoutsA: timeoutsUsed(0), timeoutsB: timeoutsUsed(1), startedAt: g.startedAt, endedAt: new Date().toISOString(),
      entry: g.manual ? 'typed in' : 'live',
      rallies: g.log.filter(function (x) { return /^[AaBb]$/.test(x); }).length, rallyLog: g.log.join(' '),
    };
    var w = s.score[0] > s.score[1] ? 0 : 1;
    outbox.push({
      clientId: payload.clientId, gameId: m.gameId, status: 'queued', payload: payload,
      label: m.flightName.replace(/ Doubles - /, ' ') + ' · ' + (m.stage === 'Round robin' ? 'R' + m.round + ' C' + m.court : m.stage) +
        ': Team ' + m.teams[0] + ' ' + s.score[0] + ' – ' + s.score[1] + ' Team ' + m.teams[1],
    });
    LS.set('outbox', outbox); LS.del('game'); game = null;
    $('doneTitle').textContent = 'Team ' + m.teams[w] + ' wins ' + Math.max.apply(null, s.score) + ' – ' + Math.min.apply(null, s.score);
    $('doneSub').textContent = 'Saved on this iPad. It goes to the Google Sheet by itself, even if the wifi is out right now.';
    show('s-done'); drawDonePill(); flush();
  }

  function drawDonePill() {
    var last = outbox[outbox.length - 1], p = $('donePill');
    if (!last) return;
    if (last.status === 'sent') { p.className = 'pill ok'; p.textContent = '✓ In the Google Sheet'; $('doneIcon').textContent = '✅'; }
    else if (last.status === 'error') { p.className = 'pill bad'; p.textContent = '⚠ The sheet refused this score. Tell the director.'; $('doneIcon').textContent = '⚠️'; }
    else { p.className = 'pill wait'; p.textContent = lastFetchFailed ? '📶 No wifi. Saved, will send when it’s back' : '⏳ Sending to the sheet…'; $('doneIcon').textContent = '💾'; }
  }
  $('doneNext').onclick = function () { show('s-home'); drawHome(); };

  var flushing = false;
  function flush() {
    if (flushing || !cfg.pin) return;
    var q = outbox.filter(function (o) { return o.status === 'queued'; })[0];
    if (!q) { updateSyncPill(); return; }
    flushing = true; updateSyncPill();
    api.submit(cfg.pin, q.payload).then(function () {
      q.status = 'sent'; lastFetchFailed = false;
    }).catch(function (err) {
      if (err.api && err.message !== 'bad_pin') { q.status = 'error'; q.error = err.message; }
      else lastFetchFailed = !err.api;
    }).then(function () {
      flushing = false; LS.set('outbox', outbox); updateSyncPill(); drawDonePill();
      if (q.status !== 'queued') { flush(); refreshSchedule(); }
    });
  }
  setInterval(flush, 10000);
  setInterval(function () { if (!$('s-home').hidden) refreshSchedule(); }, 60000);
  window.addEventListener('online', function () { flush(); refreshSchedule(); });

  function updateSyncPill() {
    var waiting = outbox.filter(function (o) { return o.status === 'queued'; }).length;
    var bad = outbox.filter(function (o) { return o.status === 'error'; }).length;
    var p = $('syncPill');
    if (bad) { p.className = 'pill bad'; p.textContent = '⚠ ' + bad + ' need the director'; }
    else if (waiting) { p.className = 'pill wait'; p.textContent = (lastFetchFailed ? '📶 No wifi · ' : '⏳ ') + waiting + ' waiting to send'; }
    else if (lastFetchFailed) { p.className = 'pill wait'; p.textContent = '📶 No wifi (scoring still works)'; }
    else { p.className = 'pill ok'; p.textContent = '✓ All saved to sheet'; }
    if (DEMO) p.textContent = 'DEMO · ' + p.textContent;
  }
  $('syncPill').onclick = function () {
    $('outList').innerHTML = outbox.length
      ? outbox.slice().reverse().slice(0, 40).map(function (o) {
        var icon = o.status === 'sent' ? '✅' : o.status === 'error' ? '⚠️' : '⏳';
        return '<div>' + icon + ' ' + esc(o.label) + (o.error ? ' (' + esc(o.error) + ')' : '') + '</div>';
      }).join('')
      : '<div>No games scored on this iPad yet.</div>';
    $('ov-sync').hidden = false;
  };
  $('syncNow').onclick = function () { flush(); refreshSchedule(); $('ov-sync').hidden = true; };
  $('syncClose').onclick = function () { $('ov-sync').hidden = true; };

  /* keep the screen on while scoring (Safari 16.4+) */
  var lock = null;
  function keepAwake() {
    if (lock || !navigator.wakeLock) return;
    navigator.wakeLock.request('screen').then(function (l) { lock = l; l.addEventListener('release', function () { lock = null; }); }).catch(function () {});
  }
  function releaseAwake() { if (lock) { lock.release(); lock = null; } }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { if (!$('s-score').hidden) keepAwake(); flush(); }
  });

  /* ---------- router: an unfinished game always comes back first ---------- */
  function route() {
    if (!cfg.pin) { show('s-pin'); return; }
    if (game) { show('s-score'); drawScore(); toast('Game restored. Keep scoring.'); return; }
    if (!cfg.scorer) { show('s-name'); $('scorerName').value = ''; return; }
    show('s-home'); drawHome();
  }

  /* ---------- demo mode: used until the Apps Script URL is filled in ---------- */
  function demoApi() {
    var grid = [[[2, 1], [3, 6], [4, 5]], [[3, 4], [6, 1], [2, 5]], [[6, 4], [2, 3], [1, 5]], [[4, 1], [5, 3], [6, 2]], [[5, 6], [1, 3], [4, 2]]];
    var names = ['Ann Hart / Bea Cole', 'Cara Diaz / Dee Fox', 'Eva Gold / Fay Hill', 'Gia Ivy / Hope Jay', 'Iris Kemp / Joy Lane', 'Kim Moss / Liv Nash'];
    var evs = [{ id: 'W', name: 'Womens Doubles', date: '2026-11-13' }, { id: 'M', name: 'Mens Doubles', date: '2026-11-15' }, { id: 'X', name: 'Mixed Doubles', date: '2026-11-16' }];
    var flights = [];
    evs.forEach(function (e) {
      [['N', 'Novice', '6:00 AM'], ['I1', 'Intermediate 1', '8:00 AM']].forEach(function (x) {
        var teams = {}; names.forEach(function (n, i) { teams[i + 1] = n; });
        flights.push({ id: e.id + '-' + x[0], event: e.id, code: x[0], name: e.name + ' - ' + x[1], time: x[2], teams: teams, rounds: grid });
      });
    });
    function data() {
      return { ok: true, rules: L.DEFAULT_RULES, medalSpots: 4, events: evs, flights: flights, scored: LS.get('demo_scored', {}), standings: {} };
    }
    return {
      schedule: function (p) {
        return new Promise(function (res, rej) { setTimeout(function () { p === '2026' ? res(data()) : rej(apiError('bad_pin')); }, 300); });
      },
      submit: function (p, g) {
        return new Promise(function (res) {
          setTimeout(function () {
            var s = LS.get('demo_scored', {}); s[g.gameId] = { scoreA: g.scoreA, scoreB: g.scoreB }; LS.set('demo_scored', s);
            res({ ok: true, status: 'saved' });
          }, 900);
        });
      },
    };
  }

  route();
  if (cfg.pin) { refreshSchedule(); flush(); }
})();
